import type {SVGProps} from 'react';
import * as React from 'react';
export const SearchIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 18 19"
		{...props}
	>
		<path
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.8}
			d="m12.233 12.477 4.876 4.877M2.001 10.491a6.288 6.288 0 1 0 11.574-4.92 6.288 6.288 0 0 0-11.574 4.92Z"
		/>
	</svg>
);
